import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { SelectItemStore, FilterStore } from '../../shared/util-stores';
import { communicationModalStore } from '../../chat/stores/communicationModalStore';
import { loggedInUserDataStore } from '../../shared/stores/loggedInUserDataStore';
import { ScholasticCustomerInfo } from '../interfaces/scholastic-list/ScholasticCustomerInfo';
import {
  ScholasticCommunicationFilterFormValue,
  ScholasticCommunicationSortField,
  ScholasticCommunicationFilters,
} from '../interfaces/scholastic-list/ScholasticCommunicationFilters';
import { scholasticCommunicationService } from '../services/scholasticCommunicationService';

class ScholasticCustomersListStore {
  customerList: ScholasticCustomerInfo[] = [];
  selectMethod: SelectItemStore<ScholasticCustomerInfo['id']>;
  filterMethod: FilterStore<
    ScholasticCommunicationFilterFormValue,
    ScholasticCommunicationSortField
  >;
  isShowCoachColumn: boolean = false;
  isShowLocationColumn: boolean = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.selectMethod = new SelectItemStore();
    this.filterMethod = new FilterStore<
      ScholasticCommunicationFilterFormValue,
      ScholasticCommunicationSortField
    >(this.handleGetCustomerList);
  }

  setDefaultValues() {
    this.customerList = [];
    this.filterMethod.setDefaultValues();
    this.selectMethod.setDefaultValues();
    this.isShowCoachColumn = false;
    this.isShowLocationColumn = false;
  }
  async getCustomerListInitData() {
    this.setShowColumnsSettings();
    Promise.all([this.getCustomerList()]);
  }

  setShowColumnsSettings() {
    const { isCoach, isSuperAdmin } = loggedInUserDataStore;

    this.isShowCoachColumn = !isCoach;
    this.isShowLocationColumn = !!isSuperAdmin;
  }

  async getCustomerList() {
    return this.filterMethod.getData();
  }

  async handleGetCustomerList(filterData: ScholasticCommunicationFilters) {
    const data = await scholasticCommunicationService.getCustomerList(filterData);
    const { content, totalElements } = data;

    const customerIds = content.map((customer) => customer.id);

    this.setCustomerList(content);

    this.selectMethod.addItems(customerIds);
    this.selectMethod.setItemCount(totalElements);

    return data;
  }

  async downloadReportForSelected() {
    this.downloadReport(false);
  }

  async downloadReportForAll() {
    this.downloadReport(true);
  }

  private async downloadReport(forAll?: boolean) {
    const customerList = this.selectMethod.getSelectedItems(forAll);

    await scholasticCommunicationService.downloadCommunicationScholasticReports({
      customerList,
      filters: this.filterMethod.filterData,
    });
  }

  sendMessageToAll() {
    this.sendMessage(true);
  }

  sendMessageToSelected() {
    this.sendMessage(false);
  }

  private sendMessage(toAll: boolean) {
    const customerIds = this.selectMethod.getSelectedItems(toAll);
    const customersCount = this.selectMethod.getSelectedItemCount(toAll);

    communicationModalStore.openCommunicationModal({
      customerIds,
      filters: this.filterMethod.filterData,
      customersCount,
      resourceType: 'scholastic',
    });
  }

  private setCustomerList(customerList: ScholasticCustomerInfo[]) {
    this.customerList = customerList;
  }
}

const scholasticCustomersListStore = new ScholasticCustomersListStore();

resetAllStore.addResetMethod(scholasticCustomersListStore.setDefaultValues);

export { scholasticCustomersListStore, ScholasticCustomersListStore };
